import React, { useEffect, useState } from 'react';
import { apiFetch } from './apiMedecins.js';

export default function Pr2NextDayWarnings({ affectations }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    let current = true;
    if (!affectations) { setState(null); return () => { current = false; }; }
    setState({ loading: true });
    const timer = setTimeout(async () => {
      let report;
      try {
        const response = await apiFetch('/api/v2/gardes/next-day-warnings', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type: 'PR2', liste: affectations }),
        });
        if (!response.ok) throw Error('Contrôle indisponible');
        report = (await response.json()).guardWarnings;
        if (!report || !Array.isArray(report.alerts)) throw Error('Réponse inexploitable');
      } catch (_) {
        report = { status: 'INCOMPLET', alerts: [], errors: [{ reason: 'Lecture des activités du lendemain impossible.' }] };
      }
      if (current) setState(report);
    }, 0);
    return () => { current = false; clearTimeout(timer); };
  }, [affectations]);
  if (!affectations || !state) return null;
  return <section aria-label="Activités du lendemain" aria-live="polite" style={{ margin: '16px 0', padding: '12px 0', borderTop: '1px solid #d1d5db' }}>
    <h3 style={{ fontSize: 16, margin: '0 0 8px' }}>Activités du lendemain</h3>
    {state.loading ? <p>Contrôle en cours…</p> : <>
      {state.status === 'INCOMPLET' && <><strong>CONTRÔLE INCOMPLET</strong>
        <ul>{state.errors.map((e, i) => <li key={i}>{[e.sector, e.date, e.reason].filter(Boolean).join(' : ')}</li>)}</ul></>}
      {state.alerts.length > 0 ? <ul>{state.alerts.map((a, i) => <li key={i}>{a.message}</li>)}</ul>
        : state.status === 'OK' && <p>Aucune activité du lendemain détectée dans les données enregistrées.</p>}
    </>}
  </section>;
}
